
import React, { useEffect } from 'react';
import { setTitle } from '../../shared/services/general/general-service';
import Footer from '../../components/footer/footer';
import ContactUsContent from './contact-us-content';

export default function ContactUs () {
	useEffect(() => {
		setTitle('تماس با ما');
	}, []);

	return (<>
		<div className="d-flex flex-column container" style={{maxWidth: '1440px', width: '100%', margin: '30px auto' }}>
			<br />
			<br />
			<div className="max-width-menu section-title clearfix"><h1>تماس با ما</h1></div>
			<br />
			<ContactUsContent></ContactUsContent>
		</div>
		<Footer></Footer>
	</>);
}
